import { isMobile } from 'react-device-detect'
import React from 'react'

/**
 * 체크박스 컴포넌트
 * @param {string} text - 라벨
 */
export const InputCheckbox = ({
  text,
  isCheckbox,
  setIsCheckbox,
  noGap,
  fontWeight,
  fontSize,
  lineHeight,
  color,
  event,
}: {
  text: string
  isCheckbox: boolean
  setIsCheckbox: React.Dispatch<React.SetStateAction<boolean>>
  noGap?: boolean
  fontWeight?: number
  fontSize?: number
  lineHeight?: string
  color?: string
  event?: any
}) => {
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: noGap ? 0 : 8,
        width: 'fit-content',
        cursor: 'pointer',
      }}
      onClick={() => {
        setIsCheckbox(!isCheckbox)
        if (event) {
          event()
        }
      }}
    >
      {isCheckbox ? (
        <img src='/images/icon_checkbox2_true.svg' alt='checkbox' style={{ width: 20, height: 20 }}></img>
      ) : (
        <img src='/images/icon_checkbox2_false.svg' alt='checkbox' style={{ width: 20, height: 20 }}></img>
      )}

      <p
        style={
          isMobile
            ? {
                fontSize: fontSize ? fontSize : 13,
                fontWeight: fontWeight ? fontWeight : 500,
                lineHeight: lineHeight ? lineHeight : '24px',
                color: color ? color : 'var(--colBlack)',
              }
            : {
                fontSize: fontSize ? fontSize : 13,
                fontWeight: fontWeight ? fontWeight : 500,
                lineHeight: lineHeight ? lineHeight : '24px',
                color: color ? color : 'var(--colBlack)',
              }
        }
      >
        {text}
      </p>
    </div>
  )
}
